import { Icon, IconVariant } from '@/components/Icon';
import LinkWrapper from '@/components/LinkWrapper';
import { SidebarNavItem } from '@/helpers/mapNavigationToSidebarItems';
import classnames from '@/utilities/classnames';

export interface SidebarNavigationItemProps extends SidebarNavItem {
  onClick?: (id: string) => void;
}

export function SidebarNavigationItem(props: SidebarNavigationItemProps) {
  function handleOnClick() {
    if (props.onClick) {
      props.onClick(props.id);
    }
  }

  return (
    <li
      className={classnames('SidebarNavigationItem', {
        'SidebarNavigationItem--current': props.current,
      })}
    >
      {props.link ? (
        <LinkWrapper
          className="SidebarNavigationItem__text"
          href={props.link}
          tabIndex={0}
          aria-current={props.current ? 'page' : undefined}
        >
          <span>{props.shortTitle || props.title}</span>
        </LinkWrapper>
      ) : (
        <button
          className="SidebarNavigationItem__text"
          onClick={handleOnClick}
          tabIndex={0}
          aria-label={props.title}
          onKeyDown={(event) => {
            if (event.key == 'Enter') {
              handleOnClick();
            }
          }}
        >
          <span>{props.shortTitle || props.title}</span>
          <Icon variant={IconVariant.ChevronRight} />
        </button>
      )}
    </li>
  );
}
